// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"31254399","555":"cfb2162b","780":"a32f3c2c","823":"55c70b33"}[chunkId] + ".chunk.js";
};